"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var mixins_1 = require("./mixins");

exports.stdLink = function (style) {
  style = style || {};
  style.color = style.color || {};
  var _style$color = style.color,
      hover = _style$color.hover,
      hout = _style$color.hout;
  return "\n\t    text-decoration: none;\n\t    ".concat(mixins_1.fgColor(hover, hout, '200ms'), "\n\t    cursor: pointer;\n\t");
};

exports.stdInput = function (style) {
  var hasError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var hasFocus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  style = style || {};
  style.color = style.color || {};
  style.padding = '0.5rem';
  var _style$color2 = style.color,
      hover = _style$color2.hover,
      hout = _style$color2.hout,
      error = _style$color2.error;
  return "\n        padding: ".concat(style.padding, ";\n        background-color: white;\n        ").concat(!hasError && hout ? "border: 1px solid ".concat(hout, ";") : '', "\n        ").concat(hasError && error ? "border: 1px solid ".concat(error, ";") : '', "\n        ").concat(hasFocus === null ? hover ? "&:hover, &:focus, &:active {border-color: ".concat(hover, ";}; transition: border-color 200ms ease;") : '' : '', "\n        ").concat(hasFocus !== null ? hover ? "\n                        &:hover {border-color: ".concat(hover, ";}; transition: border-color 200ms ease;\n                        ").concat(hasFocus ? "border-color: ".concat(hover, ";") : '', "\n                    ") : '' : '', "\n    \n        border-radius: 2px;\n    ");
};